import { NgModule } from '@angular/core';
import { CommonModule as AngularCore } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { ComponentsModule } from '../../../components/components.module';
import { PipesModule } from '../../../pipes/pipes.module';

import { LearnPaginationComponent } from './learn-pagination.component';

@NgModule({
  imports: [
    AngularCore,
    TranslateModule.forChild(),
    ComponentsModule,
    PipesModule,
    LearnPaginationComponent
  ],
  exports: [
    LearnPaginationComponent
  ]
})
export class LearnPaginationModule {
}

